import statusBoxPlaceholder from './status-box-placeholder.webp';
import check from './check.webp';
import AmethystLockedBadge from './badges/amethyst_locked.webp';
import AmethystBadge from './badges/amethyst.webp';
import TopazBadge from './badges/topaz.webp';
import AquamarineBadge from './badges/aquamarine.webp';
import OpalBadge from './badges/opal.webp';
import EmeraldBadge from './badges/emerald.webp';
import RubyBadge from './badges/ruby.webp';
import SapphireBadge from './badges/sapphire.webp';
import DiamondBadge from './badges/diamond.webp';
import VipBadge from './badges/vip.webp';
import AmethystGem from './gems/amethyst.webp';
import TopazGem from './gems/topaz.webp';
import AquamarineGem from './gems/aquamarine.webp';
import OpalGem from './gems/opal.webp';
import EmeraldGem from './gems/emerald.webp';
import RubyGem from './gems/ruby.webp';
import SapphireGem from './gems/sapphire.webp';
import DiamondGem from './gems/diamond.webp';
import VipGem from './gems/vip.webp';

export default {
  statusBoxPlaceholder,
  check,
  AmethystLockedBadge,
  AmethystBadge,
  TopazBadge,
  AquamarineBadge,
  OpalBadge,
  EmeraldBadge,
  RubyBadge,
  SapphireBadge,
  DiamondBadge,
  VipBadge,
  AmethystGem,
  TopazGem,
  AquamarineGem,
  OpalGem,
  EmeraldGem,
  RubyGem,
  SapphireGem,
  DiamondGem,
  VipGem,
};
